

// Utility to format date as YYYY-MM-DD
export const formatDate = date =>
    new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];

// Shared color palette for charts
export const chartColorPalette = [
            '#5470C6', // blue
            '#91CC75', // green
            '#FAC858', // yellow
            '#73C0DE', // cyan
            '#9A60B4', // purple
            '#EA7CCC' // pink
];
